import React from 'react';
import { useHoliday } from '@/contexts/HolidayContext';
import ChristmasDecorations from './ChristmasDecorations';
import NewYearsDecorations from './NewYearsDecorations';
import ValentinesDecorations from './ValentinesDecorations';
import StPatricksDecorations from './StPatricksDecorations';
import July4thDecorations from './July4thDecorations';
import HalloweenDecorations from './HalloweenDecorations';
import ThanksgivingDecorations from './ThanksgivingDecorations';

const HolidayDecorations = () => {
  const { activeHoliday, isLoading } = useHoliday();

  if (isLoading || !activeHoliday) {
    return null;
  }

  switch (activeHoliday) {
    case 'christmas':
      return <ChristmasDecorations />;
    case 'newyears':
      return <NewYearsDecorations />;
    case 'valentines':
      return <ValentinesDecorations />;
    case 'stpatricks':
      return <StPatricksDecorations />;
    case 'july4th':
      return <July4thDecorations />;
    case 'halloween':
      return <HalloweenDecorations />;
    case 'thanksgiving':
      return <ThanksgivingDecorations />;
    default:
      return null;
  }
};

export default HolidayDecorations;
